module.exports = __webpack_public_path__ + "static/img/eyes_10.c23ff97.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_10.png
// module id = b9X7
// module chunks = 0